module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/item-3-883e60e2027913896097b4aa026d98e5.jpg";